@if (claim?.claimType === claimTypes.INVOLUNTARY_UNEMPLOYMENT) {
    <app-employer-response-unemployment></app-employer-response-unemployment>
}
@if (claim?.claimType === claimTypes.JOB_RELOCATION) {
    <app-employer-response-job-relocation></app-employer-response-job-relocation>
}
